import React from "react"
import styles from "./styles.scss"
import cx from "classnames"

class AboutUs extends React.Component {
  render() {
    return (
      <section
        className={cx(styles.container, {
          [styles.light]: this.props.variant === "light",
        })}
      >
        <div className={styles.wrapper}>
          <h2>Om oss</h2>
          <p>
            SAITS kombinerar kompetensen hos en stor webbyrå med servicen hos en
            liten. Hos oss handlar det alltid om resultat, värde och stolthet.
            Vi vill att den färdiga produkten ska ge det resultat som du
            förväntar dig, att den ska ge värde åt företaget och att båda parter
            ska känna stolthet över den.
          </p>
          <p>
            Vi finns i Uppsala – men det behöver inte betyda att du finns här.
            Att jobba flexibelt är en förutsättning för oss och det finns många
            smarta sätt för att ni ska kunna känna er delaktiga i projektet utan
            fysiska möten. Bara hör av er till oss så kommer vi hitta ett
            arbetssätt som funkar för oss båda!
          </p>
        </div>
      </section>
    )
  }
}

export default AboutUs



// WEBPACK FOOTER //
// ./src/pages/LandingPage/AboutUs/index.jsx